import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AnimateHeight from 'react-animate-height';

import { getUserAccounts, showEditUser } from '../../actions/mainview/mainview';
import { deleteUser } from '../../actions/app/app';

import Helper from '../../helpers/helper';

const AccountList = () => {

  const dispatch = useDispatch(),
        appProps = useSelector(store => store.app),
        mainviewProps = useSelector(store => store.mainview),
        isUserAdmin = appProps.loggedInUser?.is_admin, // isAdmin variable named differently to not confuse with admin filter
        [userList, setUserList] = useState([]),
        [currentPage, setCurrentPage] = useState(1),
        [searchTerm, setSearchTerm] = useState(null),
        [searchTermAdmin, setSearchTermAdmin] = useState(null),
        [searchTermAkf, setSearchTermAkf] = useState(null),
        [searchTermLic, setSearchTermLic] = useState(null),
        [totalPages, setTotalPages] = useState(1),
        [showFilters, setShowFilters] = useState(false),
        [height, setHeight] = useState(0);
        
  useEffect(() => dispatch(getUserAccounts(currentPage, searchTerm, searchTermAdmin, searchTermAkf, searchTermLic)), [dispatch]);

  useEffect(() => {
    setUserList(mainviewProps.userAccountListData?.results);
    setCurrentPage(mainviewProps.userAccountListData?.current_page);
    setTotalPages(mainviewProps.userAccountListData?.total_pages);
  }, [mainviewProps.userAccountListData]);

  const _handleFormSubmit = e => {
    e.preventDefault();

    dispatch(getUserAccounts(currentPage, searchTerm, searchTermAdmin, searchTermAkf, searchTermLic));
  }

  const _showAll = () => {
    setSearchTerm(null);
    setSearchTermAdmin('null');
    setSearchTermAkf('null');
    setSearchTermLic('null');
    dispatch(getUserAccounts(currentPage));
  }

  const _nextPage = () => dispatch(getUserAccounts(null, null, null, null, null, null, mainviewProps.userAccountListData?.next));
  const _prevPage = () => dispatch(getUserAccounts(null, null, null, null, null, mainviewProps.userAccountListData?.previous, null));
 
  const _toggleFilters = () => {
    setHeight(!showFilters ? 'auto' : 0);
    setShowFilters(!showFilters);
  }

  const _deleteAccount = account => {
    if (appProps.loggedInUser.user.id === account.user.id) return Helper.setNotification('info', 'Unable to delete account', 'You can\'t delete your own account!', true);

    if (!window.confirm('Are you sure you wish to delete this account?')) return false;

    dispatch(deleteUser(account));
    dispatch(getUserAccounts(currentPage, searchTerm, searchTermAdmin, searchTermAkf, searchTermLic));
  }

  return (
    <>
      <>
        <AnimateHeight duration={ 300 } height={ height }>
          <form onSubmit={ e => _handleFormSubmit(e) } className="form">
            <div className="form__group form__group--horizontal">
              {
                isUserAdmin ?
                (
                  <>
                    <fieldset className="form__item-container">
                      <p className="form__label">{ searchTermAdmin === 'null' || searchTermAdmin === null ? 'No admin filter' : searchTermAdmin === 'true' ? 'Show admin accounts' : 'Hide admin accounts' }</p>
                      <div className="form__radio" title="No filter for admins">
                        <input type="radio" className="form__radio-input" id="adminDefault" name="adminFilter" value="null" onChange={ e => setSearchTermAdmin(e.currentTarget.value) } defaultChecked />
                        <label htmlFor="adminDefault" className="form__radio-label">No admin filter</label>
                      </div>
                      <div className="form__radio" title="Filter to show admin accounts">
                        <input type="radio" className="form__radio-input" id="adminOn" name="adminFilter" value="true" onChange={ e => setSearchTermAdmin(e.currentTarget.value) } />
                        <label htmlFor="adminOn" className="form__radio-label">Show admins</label>
                      </div>
                      <div className="form__radio" title="Filter to hide admin accounts">
                        <input className="form__radio-input" type="radio" id="adminOff" name="adminFilter" value="false" onChange={ e => setSearchTermAdmin(e.currentTarget.value) } />
                        <label htmlFor="adminOff" className="form__radio-label">Hide admins</label>
                      </div>
                      {/* <div data-label={ searchTermAdmin ? 'Showing admins' : 'Any admin' } className="form__switch">
                        <input type="checkbox" name="admin" className="form__switch-checkbox" id="admin" onChange={ e => setSearchTermAdmin(e.target.checked) } />
                        <label className="form__switch-label" htmlhtmlFor="admin"></label>
                      </div> */}
                    </fieldset>
                    <fieldset className="form__item-container">
                      <p className="form__label">{ searchTermAkf === 'null' || searchTermAkf === null ? 'No staff filter' : searchTermAkf === 'true' ? 'Show AKF staff' : 'Hide AKF staff' }</p>
                      <div className="form__radio" title="No filter for staff">
                        <input type="radio" className="form__radio-input" id="staffdefault" name="staffFilter" value="null" onChange={ e => setSearchTermAkf(e.currentTarget.value) } defaultChecked />
                        <label htmlFor="staffdefault" className="form__radio-label">No staff filter</label>
                      </div>
                      <div className="form__radio" title="Filter to show staff accounts">
                        <input type="radio" className="form__radio-input" id="staffOn" name="staffFilter" value="true" onChange={ e => setSearchTermAkf(e.currentTarget.value) } />
                        <label htmlFor="staffOn" className="form__radio-label">Show AKF staff members</label>
                      </div>
                      <div className="form__radio" title="Filter to hide staff accounts">
                        <input className="form__radio-input" type="radio" id="staffOff" name="staffFilter" value="false" onChange={ e => setSearchTermAkf(e.currentTarget.value) } />
                        <label htmlFor="staffOff" className="form__radio-label">Hide AKF staff members</label>
                      </div>
                      {/* <div data-label={ searchTermAkf ? 'Showing AKF staff' : 'Any AKF staff' } className="form__switch">
                        <input type="checkbox" name="akf" className="form__switch-checkbox" id="akf" onChange={ e => setSearchTermAkf(e.target.checked) } />
                        <label className="form__switch-label" htmlhtmlFor="akf"></label>
                      </div> */}
                    </fieldset>
                    <fieldset className="form__item-container">
                    <p className="form__label">{ searchTermLic === 'null' || searchTermLic === null ? 'No license filter' : searchTermLic === 'true' ? 'Show licensed users' : 'Hide licensed users' }</p>
                      <div className="form__radio" title="No filter for staff">
                        <input type="radio" className="form__radio-input" id="licenseDefault" name="licenseFilter" value="null" onChange={ e => setSearchTermLic(e.currentTarget.value) } defaultChecked />
                        <label htmlFor="licenseDefault" className="form__radio-label">No licensed users filter</label>
                      </div>
                      <div className="form__radio" title="Filter to show license accounts">
                        <input type="radio" className="form__radio-input" id="licenseOn" name="licenseFilter" value="true" onChange={ e => setSearchTermLic(e.currentTarget.value) } />
                        <label htmlFor="licenseOn" className="form__radio-label">Show licensed users</label>
                      </div>
                      <div className="form__radio" title="Filter to hide license accounts">
                        <input className="form__radio-input" type="radio" id="licenseOff" name="licenseFilter" value="false" onChange={ e => setSearchTermLic(e.currentTarget.value) } />
                        <label htmlFor="licenseOff" className="form__radio-label">Hide licensed users</label>
                      </div>
                      {/* <div data-label={ searchTermLic ? 'Showing licensed users' : 'Any licensed users' } className="form__switch">
                        <input type="checkbox" name="license" className="form__switch-checkbox" id="license" onChange={ e => setSearchTermLic(e.target.checked) } />
                        <label className="form__switch-label" htmlhtmlFor="license"></label>
                      </div> */}
                    </fieldset>
                  </>
                ) : null
              }
            </div>
            
            <div className="form__group">
              <input onChange={ e => setSearchTerm(e.target.value) } placeholder="Search for an email address or a name&hellip;" className="form__input" />
            </div>
            
            <div className="form__button-group">
              <button onClick={ () => _showAll() } className="form__button button button--hollow" type="reset" title="Reset this search">Reset</button>
              <button type="submit" className="form__button button" disabled={ appProps.loading } title="Search">Search</button>
            </div>
          </form>
        </AnimateHeight>
        <div className="form__filter-toggle" onClick={ () => _toggleFilters() }>
          <span className="form__filter-toggle-text">{ showFilters ? 'Hide' : 'Show' } filters <i className={ `fas fa-${ showFilters ? 'chevron-up' : 'chevron-down' }` } style={{ marginLeft: 5 }}></i></span>
        </div>
      </>
      
      {
        appProps.loading ?
        (
          <div className="search-list__loader">Loading&hellip;</div>
        ) :
        (
          <ul className={ `search-list ${ userList?.length > 5 ? 'search-list--restricted' : '' }` }>
            {
              userList !== null &&
              <>
                {
                  userList.length > 0 ?
                  (
                    userList.map((item, i) => (
                      <li key={ i } className="search-list__item">
                        <figure className="search-list__item-info">
                          {
                            item.user?.first_name !== null &&
                            <figcaption className="search-list__item-text">{ item.user.first_name } { item.user.last_name } { appProps.loggedInUser.user.id === item.user.id ? '(you)' : '' }</figcaption>
                          }
      
                          {
                            item.user?.email !== null &&
                            <figcaption className="search-list__item-text">{ item.user.email }</figcaption>
                          }
      
                          <figcaption className="search-list__item-text">Updated date: { new Date(item.updated_date).toLocaleString('en-AU') }</figcaption>
           
                          <figcaption className="search-list__item-text">
                            {
                              item.user?.is_active &&
                              <span className="badge" title="User is active">Active</span>
                            }
                            {
                              !item.user?.is_active &&
                              <span className="badge badge--dark" title="User is locked">Locked</span>
                            }
                            {
                              item.is_admin &&
                              <span className="badge" title="User is an admin">Admin</span>
                            }
                            {
                              item.is_akfstaff &&
                              <span className="badge" title="User is an AKF staff member">AKF staff</span>
                            }
                            {
                              item.is_licenseduser &&
                              <span className="badge" title="User is licensed">Licensed</span>
                            }
                          </figcaption>
                        </figure>
                        <div className="search-list__item-controls">
                          <span onClick={ () => dispatch(showEditUser(item)) } title="Edit this account" className="button button--reduced">Edit</span>
                          {
                            isUserAdmin &&
                            appProps.loggedInUser.user.id !== item.user.id ?
                            (
                              <span onClick={ () => _deleteAccount(item) } title="Delete this account" className="button button--reduced button--danger">Delete</span>
                            ) :
                            null
                          }
                        </div>
                      </li>
                    ))        
                  ) :
                  (
                    <p style={{ marginTop: 20 }}>No matching accounts.</p>
                  )
                }
              </>
            }
          </ul>
        )
      }

      {
        userList?.length > 0 &&
        <div className="pagination">
          {
            currentPage > 1 &&
            <span title="Previous page" className="pagination__direction" onClick={ () => _prevPage() }><i className="fas fa-chevron-left"></i></span>
          }
          <span className="pagination__content">Page { currentPage } of { totalPages }</span>
          {
            totalPages > 1 &&
            <span title="Next page" className="pagination__direction" onClick={ () => _nextPage() }><i className="fas fa-chevron-right"></i></span>
          }
        </div>
      }
      
    </>
  );

}

export default AccountList;